import { defineNuxtPlugin } from '#imports'

import { updateUserContext } from '../utils/tracking/updateUserContext'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('oauth:user-fetched', async () => {
    void updateUserContext()
  })
})
